<template>
  <div class="section2">
    <div class="title">通友是什么?</div>
    <div class="swipper">
      <transition name="fade">
        <div class="swipper-item" v-if="currentIndex == 0">
          &nbsp;&nbsp;&nbsp;&nbsp;通友是一款全球社交聊天软件，每1位都有自己的社交网络，用户之间可以通过通友进行方便的交流，可以顺畅的分享自己看到的喜欢的商品、图片、文字、视频等信息，更可以直接分享商品链接给好友，方便直接下单购买，大大的提升商品信息的分享度。同时，通友商城是款自带翻译功能的全球社交软件，使您可以毫无压力
的把商品分享给全球的陌生的朋友~
        </div>
      </transition>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      currentIndex: 0
    };
  }
};
</script>

<style lang="scss" scoped>
.section2 {
  position: relative;
  height: 5.4rem;
  background: #fff;
  .title {
    position: relative;
    font-size: 0.3rem;
    line-height: 0.18rem;
    padding-top: 0.535rem;
    padding-bottom: 0.2rem;
    padding-left: 0.1rem;
    margin: 0 0.66rem;
    text-align: center;
    box-sizing: border-box;
    color: #000;
  }
  .fade-enter-active,
  .fade-leave-active {
    transition: all 0.5s;
  }
  .fade-enter {
    opacity: 0;
    transform: translate(-50%, 0);
  }
  .fade-leave-to {
    opacity: 0;
    transform: translate(50%, 0);
  }
  .swipper {
    position: absolute;
    top: 1.295rem;
    left: 1rem;
    height: 4.1rem;
    width: 8.6rem;
    .swipper-item {
      position: absolute;
      top: 0;
      left: 1.2rem;
      width: 5rem;
      height: 3.1rem;
      display: flex;
      color: #333;
      font-size: 0.12rem;
      flex-direction: row;
      justify-content: center;
      text-indent: 0.25rem;
    }
  }
}
</style>
